import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const widgetsBreadCrumbs: Array<PageLink> = [];

const RecoverBalancePage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Recuperar saldo</PageTitle>
      <View />
    </>
  );
};

export { RecoverBalancePage };
